import React, { useCallback, useEffect, useState } from 'react';
import { FiMessageSquare } from 'react-icons/fi';

export default function ContadorNoteBanner({
  secureFetch,
  modoOscuro,
  box,
  textPri,
  textSec,
  textMuted,
}) {
  const [latest, setLatest] = useState(null);
  const [disclaimer, setDisclaimer] = useState('');
  const [ack, setAck] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await secureFetch('/api/contador/notas');
      if (!res.ok) return;
      const json = await res.json();
      setLatest(json.latest || null);
      setDisclaimer(json.disclaimer || '');
    } catch {
      setLatest(null);
    }
  }, [secureFetch]);

  useEffect(() => {
    load();
  }, [load]);

  if (!latest?.text) return null;

  const unread = !latest.readAt;

  return (
    <section className={`rounded-2xl border overflow-hidden ${box}`}>
      <div className="px-4 py-3 space-y-2">
        <div className="flex flex-wrap items-center gap-2">
          <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wide ${
            modoOscuro ? 'bg-sky-900/40 text-sky-200' : 'bg-sky-50 text-sky-800'
          }`}>
            <FiMessageSquare className="w-3 h-3" />
            Nota de tu contador
          </span>
          {unread && (
            <span className={`text-[10px] font-semibold ${modoOscuro ? 'text-amber-300' : 'text-amber-700'}`}>
              Nueva
            </span>
          )}
        </div>
        <p className={`text-sm leading-relaxed ${textPri}`}>{latest.text}</p>
        <p className={`text-[11px] ${textSec}`}>
          {latest.authorName}
          {latest.createdAt ? ` · ${new Date(latest.createdAt).toLocaleDateString('es-AR')}` : ''}
        </p>
        {disclaimer && <p className={`text-[10px] ${textMuted}`}>{disclaimer}</p>}
        {unread && (
          <button
            type="button"
            disabled={ack}
            onClick={async () => {
              setAck(true);
              try {
                const res = await secureFetch('/api/contador/notas/leida', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: latest.id }),
                });
                const json = await res.json();
                if (res.ok) setLatest(json.latest || { ...latest, readAt: new Date().toISOString() });
              } finally {
                setAck(false);
              }
            }}
            className="text-[11px] font-semibold text-[#1F80FF] hover:underline disabled:opacity-50"
          >
            Entendido
          </button>
        )}
      </div>
    </section>
  );
}
